import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, inject } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withViewTransitions } from '@angular/router';
import { InMemoryCache } from '@apollo/client/core';
import { provideSvgIconsConfig } from '@ngneat/svg-icon';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { Amplify } from 'aws-amplify';

import { createAppConfig } from '@/config/app.config';
import { DOMAIN_CONFIG, DomainConfiguration } from '@/config/domain.config';
import { environment } from '@/environments/environment';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/core/auth/auth.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { ICONS } from './icons';

// Configure AWS Amplify before bootstrapping the application
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolClientId,
    },
  },
  API: {
    GraphQL: {
      endpoint: environment.appSync.amplifyEndpoint,
      region: environment.appSync.region,
      defaultAuthMode: 'userPool',
    },
  },
});

fetch('./assets/domain/domain-config.json')
  .then((resp: Response) => resp.json())
  .then((config: DomainConfiguration) => {
    const { teamId, teamName, teamCode } = config;
    const domainConfig: DomainConfiguration = {
      teamId,
      teamName,
      teamCode,
    };
    bootstrapApplication(AppComponent, {
      ...createAppConfig(domainConfig),
      providers: [
        importProvidersFrom(BrowserModule),
        provideRouter(routes, withViewTransitions()),
        provideAnimations(),
        provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
        {
          provide: DOMAIN_CONFIG,
          useValue: domainConfig,
        },
        provideSvgIconsConfig({
          sizes: {
            xxs: '8px',
            xs: '10px',
            sm: '12px',
            md: '16px',
            lg: '20px',
            xl: '25px',
            xxl: '30px',
          },
          defaultSize: 'md',
          icons: ICONS,
        }),
        // Apollo solo para queries y mutations (HTTP)
        provideApollo(() => {
          const httpLink = inject(HttpLink);
          return {
            link: httpLink.create({
              uri: '/graphql',
            }),
            cache: new InMemoryCache(),
            connectToDevTools: true,
          };
        }),
      ],
    }).catch((err: Error) => console.error(err));
  });
